import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { of } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Calendar2Service {

  constructor(private http: HttpClient, private _cookiesService: CookieService) { }

  /***
* Get All events
*/
  getAllEvents() {
    return this.http.get<any>(`${environment.apiUrl}/calendar`, { withCredentials: true })
      .pipe(first(), map(data => data),
        catchError(error => {
          return of({ eventTypes: [] })
        }));
  }

  /***
 * Get All event type
 */
  getAllEventType() {
    return this.http.get<any>(`${environment.apiUrl}/calendar/event-types`, { withCredentials: true })
      .pipe(first(), map(data => data),
        catchError(error => {
          return of({ eventTypes: [] })
        }));
  }

  /**
 * Create event
 * @param data 
 * @returns 
 */
  create(body: any, dataMail?: {
    clientMail?: string,
    clientName?: string,
    clientPhone?: string,
    property?: string,
    ownerMeeting?: boolean,
    customMailSubject?: string,
    customMailBody?: string,
  }) {
    const lang = this._cookiesService.get("lang");
    const payLoad = {
      ...body,
      ...(dataMail || {}),
      lang
    }
    return this.http.post<any>(`${environment.apiUrl}/calendar`, payLoad, { withCredentials: true })
      .pipe(first());
  }

  /**
* Update event
* @param data 
* @returns 
*/
  update(id: any, payLoad: any) {
    const lang = this._cookiesService.get("lang");
    payLoad.lang = lang

    return this.http.patch<any>(`${environment.apiUrl}/calendar/${id}`, payLoad, { withCredentials: true })
      .pipe(first());
  }

  /**
* Delete event
* @param data 
* @returns 
*/
  delete(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}/calendar/${id}`, { withCredentials: true })
      .pipe(first());
  }

  /***
* Get properties
*/
  getProperties(search: any) {
    let params = new HttpParams();
    if (search !== '') params = params.set('search', search);

    return this.http.get<any>(`${environment.apiUrl}/calendar/properties`, { params, withCredentials: true })
      .pipe(first(), map(data => data),
        catchError(error => {
          return of({ properties: [] })
        }));
  }

  deletVisitEvent(id: number) {
    return this.http.delete<any>(`${environment.apiUrl}/calendar/delete-visit-event/${id}`, { withCredentials: true })
      .pipe(first());
  }


  /**
   * Cancelamento não destrutivo: a visita fica como histórico e só o evento
   * de calendário é removido. Apagar de vez é deletVisitEvent, e o backend
   * reserva-o ao MASTER.
   */
  cancelVisit(id: number, reason: string) {
    return this.http
      .patch<any>(
        `${environment.apiUrl}/calendar/cancel-visit/${id}`,
        { reason },
        { withCredentials: true },
      )
      .pipe(first());
  }

  visitedProperty(id: number, data: any) {
    return this.http.patch<any>(`${environment.apiUrl}/calendar/visited-property/${id}`,data ,{ withCredentials: true }).pipe(first());

  }
}
